import { render, staticRenderFns } from "./SetUpYHInfo.vue?vue&type=template&id=0800946e&"
import script from "./SetUpYHInfo.vue?vue&type=script&lang=js&"
export * from "./SetUpYHInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetUpYHInfo.vue?vue&type=style&index=0&id=0800946e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports